import React from 'react';
import parser from 'html-react-parser';
import { Container } from './style';

const CardProgress = ({ image, title, subtitle, children, comentary }: any) => (
  <Container className="boxShadow">
    <div className="image">
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={`${image[1]} 768w`}
          sizes="768px"
        />
        <source srcSet={`${image[0]}`} />
        <img src={image} alt="" />
      </picture>
    </div>
    <div>
      <p className="title">{parser(title)}</p>
      <div className="subtitle">{parser(subtitle)}</div>
      {comentary && (
        <p className="commentary">
          <b>Comentario: </b>
          {parser(comentary)}
        </p>
      )}

      {children}
    </div>
  </Container>
);

CardProgress.defaultProps = {
  title: '',
  subtitle: '',
  comentary: ''
};

export default CardProgress;
